<div *adaptLoading="!isInitialised"
     class="m-3 d-flex flex-column w-100">
    @if (item) {
        <div class="d-flex align-items-center gap-2">
            <h3 class="m-0">{{ item.code }}</h3>
            <adapt-display-item-status [itemStatus]="item.status"
                                       class="mx-1"></adapt-display-item-status>
            <div class="ms-auto">
                <button adaptButton="editBorderless"
                        [adaptBlockingClick]="openItem"
                        data-test="open-preview-item"></button>
                <button adaptButton="closeBorderless"
                        (click)="closeClicked.emit()"></button>
            </div>
        </div>
        <adapt-display-labels class="mt-2"
                              [labelLocations]="item.labelLocations"></adapt-display-labels>
        <div class="mt-4 d-flex flex-row align-items-center gap-2">
            <adapt-link-person [person]="item.assignee"
                               [imageOnly]="true"></adapt-link-person>
            <div class="d-flex flex-column">
                <adapt-item-link [item]="item"
                                 [hideItemCode]="true"></adapt-item-link>
                @if (item.dueDate) {
                    <small class="d-block">Due: {{ item.dueDate | adaptDate }}</small>
                }
            </div>
        </div>
        <div class="d-flex">
            <adapt-see-more [maxHeight]="110">
                <div class="mt-3 mb-1"
                     [froalaView]="item.description"
                     data-test="preview-description"></div>
            </adapt-see-more>
        </div>
        @if (item.links?.length) {
            <div class="mt-4 d-flex flex-column">
                <h4 class="mb-0">Links</h4>
                <div class="mt-1 d-flex flex-column gap-1">
                    @if (linkedObjectives.length) {
                        <small>Objectives</small>
                        <adapt-display-linked-objectives [objectives]="linkedObjectives"
                                                         [showGroupObjectiveTextSuffix]="false"></adapt-display-linked-objectives>
                    }
                    @if (itemToItemLinks.length) {
                        <small>Actions</small>
                    }
                    @for (link of itemToItemLinks; track link) {
                        <adapt-item-link [item]="link.linkedItem"
                                         [showPersonImageLink]="true"
                                         [showDialogLink]="true"
                                         [showStatus]="true"
                                         [showSummary]="true"></adapt-item-link>
                    }
                    @if (linkedMeetings.length || catchupLink || careerValuationLink) {
                        <div class="d-flex flex-column gap-1">
                            <small> Associated activities </small>
                            @for (linkedMeeting of linkedMeetings; track $index) {
                                <adapt-link-team-meeting [meeting]="linkedMeeting"></adapt-link-team-meeting>
                            }
                            @if (catchupLink) {
                                <adapt-catchup-link [catchupLink]="catchupLink"></adapt-catchup-link>
                            }
                            @if (careerValuationLink) {
                                <adapt-cvt-link [careerValuationLink]="careerValuationLink"></adapt-cvt-link>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        <div class="mt-4 d-flex flex-column flex-grow-1">
            <h4>Comments</h4>
            <adapt-comment-chain class="d-flex flex-column flex-grow-1 mb-n3 add-comment-smaller-width"
                                 [comments]="itemComments"
                                 [allowNewCommentSave]="!!newComment$"
                                 [createComment$]="newComment$"
                                 [createNewCommentAfterSave]="false"
                                 [focusAddCommentOnInit]="true"
                                 (saved)="onNewCommentSaved()"
                                 (newCommentDiscarded)="newComment$ = undefined"></adapt-comment-chain>
        </div>
        @if (hasEditAccessToItem$ | async) {
            @if (!newComment$) {
                <div class="panel-bottom align-items-end pb-3">
                    <adapt-add-comment-place-holder [item]="item"
                                                    (newCommentAdded)="onNewCommentAdded($event)"
                                                    data-test="add-comment-place-holder"></adapt-add-comment-place-holder>
                </div>
            }
        }
    } @else {
        <span>No action selected</span>
    }
</div>
